/**
 * 前端多语言解决方案
 */
import _ from 'underscore';
import LangPack from './pack';

let _lang = {
   
    tpl: function(tplStr, data, insertEM){
        let lang = UpSDK.config.language;
        let langType = lang.replace('-', '').toLowerCase();
        
        let langPack = LangPack[langType] || LangPack['zhcn'];
        
        let tpl = langPack[tplStr] || tplStr;

        try{
            if (tpl) {
                if (tpl.indexOf('@@@@') > 0) {
                    let strArr = [];
                    
                    strArr.push('<ul>');
                    tpl.split('@@@@').forEach(function(item, index){
                        item && strArr.push('<li>' + item + '</li>');
                    }); 
                    strArr.push('</ul>');
                    tpl = strArr.join('');   
                }
                if (insertEM) {
                    tpl = tpl.replace(/<%=([\s\S]+?)%>/g, function($0, $1){
                        return '<em class="' + $1 +'">' + $0+ '</em>';
                    });     
                }

                let compiled = _.template(tpl);
                return compiled(data);

            } else {
                return _.template(tplStr)(data);
            }
        } catch(e){
            console.log(e.message);
        }
    }
};

Uplib.tpl = _lang.tpl;

module.exports = _lang;


// WEBPACK FOOTER //
// ./js/component/openjs/lang/index.js